module.exports = __webpack_public_path__ + "img/horizontal_4_5_pp2_4.3a660162.png";